/** 行程编辑器、页面预览和文件输出共用的服务标准类别。 */
export const ITINERARY_SERVICE_STANDARD_TYPES = [
  ["transport", "交通标准"],
  ["stay", "住宿标准"],
  ["meal", "餐饮标准"],
  ["ticket", "门票标准"],
  ["insurance", "保险标准"],
  ["guide", "导游/领队服务"],
  ["excluded", "不含项目"],
  ["intangible_heritage", "非遗项目"],
  ["agency_payment", "代收代付"],
  ["enterprise_visit", "企业考察"],
  ["other", "其他说明"],
  ["photography", "摄影服务"],
] as const;

const SERVICE_STANDARD_LABELS = new Map<string, string>(ITINERARY_SERVICE_STANDARD_TYPES);

/** 返回服务标准类别中文名，兼容尚未登记的历史扩展 key。 */
export function itineraryServiceStandardLabel(key: string): string {
  return SERVICE_STANDARD_LABELS.get(key) ?? key;
}
